React = require 'react'
ReactDnd = require 'react-dnd'
{ BoardSection } = require './presentational/board'

_HomeBoardDndContainer = class extends React.Component
  displayName: 'HomeBoardDndContainer'
  render: ->
    { connectDropTarget } = @props
    connectDropTarget(React.createElement('div', {}, React.createElement(BoardSection, @props)))

spec =
  drop: ->

collect = (connect, monitor) ->
  connectDropTarget: connect.dropTarget()

module.exports = ReactDnd.DropTarget('HomeBoardTile', spec, collect)(_HomeBoardDndContainer)
